import * as T from 'three';
import type { SimState } from './types';

export class WaterEffects {
    private previous: number[] = [];
    private clock = 0;
    private next = 0;
    private rings: { mesh: T.Mesh<T.RingGeometry, T.MeshBasicMaterial>; age: number }[] = [];
    private droplets: { p: T.Vector3; v: T.Vector3; age: number }[] = [];
    private spray = new T.InstancedMesh(new T.SphereGeometry(.065, 5, 4), new T.MeshBasicMaterial({ color: '#d3f4e8' }), 32);
    private dummy = new T.Object3D();
    constructor(scene: T.Scene) {
        for (let i = 0; i < 12; i++) {
            const mesh = new T.Mesh(new T.RingGeometry(.9, 1, 40), new T.MeshBasicMaterial({ color: '#c5eee2', transparent: true, opacity: 0, depthWrite: false, side: T.DoubleSide }));
            mesh.rotation.x = -Math.PI / 2;
            mesh.visible = false;
            this.rings.push({ mesh, age: 2 });
            scene.add(mesh);
        }
        this.spray.count = 0;
        this.spray.frustumCulled = false;
        scene.add(this.spray);
    }
    update(dt: number, actors: SimState[], level: number, animate = true) {
        if (!animate) return;
        this.clock += dt;
        actors.forEach((s, index) => {
            if (s.mode === 4 && (this.previous[index] !== 4 || this.clock > .4)) {
                const ring = this.rings[this.next++ % this.rings.length];
                ring.age = 0;
                ring.mesh.position.set(s.p[0], level + .025, s.p[2]);
                if (this.previous[index] !== 4) {
                    for (let i = 0; i < 16; i++) {
                        const a = i * Math.PI / 8;
                        this.droplets.push({ p: new T.Vector3(s.p[0], level + .05, s.p[2]), v: new T.Vector3(Math.sin(a) * 1.8, 2.2 + (i % 3) * .45, Math.cos(a) * 1.8), age: 0 });
                    }
                    this.droplets = this.droplets.slice(-32);
                }
            }
            this.previous[index] = s.mode;
        });
        if (this.clock > .4) this.clock = 0;
        for (const r of this.rings) {
            r.age += dt;
            r.mesh.visible = r.age < 1.5;
            r.mesh.scale.setScalar(.3 + r.age * 1.4);
            r.mesh.material.opacity = Math.max(0, 1 - r.age / 1.5) * .45;
        }
        this.droplets = this.droplets.filter(d => d.age < .75 && d.p.y > level - .1);
        this.droplets.forEach((d, i) => {
            d.age += dt; d.v.y -= 7 * dt; d.p.addScaledVector(d.v, dt);
            this.dummy.position.copy(d.p); this.dummy.updateMatrix(); this.spray.setMatrixAt(i, this.dummy.matrix);
        });
        this.spray.count = this.droplets.length;
        this.spray.instanceMatrix.needsUpdate = true;
    }
}
